import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from '../../../shared/services/baseQuery';

import type { InsightDashboardData } from './insightDashboardTypes';

const INSIGHT_DASHBOARD_API_SLICE_NAME = 'insightDashboardApi';

export const insightDashboardApi = createApi({
  reducerPath: INSIGHT_DASHBOARD_API_SLICE_NAME,
  baseQuery: axiosBaseQuery({}),
  endpoints: () => ({}),
});

interface GetInsightDataParams {
  requestAccessKey: string;
}

export const insightDashboardApiEndpoints = insightDashboardApi.injectEndpoints(
  {
    endpoints: (builder) => ({
      getInsightData: builder.query<InsightDashboardData, GetInsightDataParams>(
        {
          query: ({ requestAccessKey }) => ({
            url: `/api/activity-log/v1/request/${requestAccessKey}/insights`,
            isECMv6: true,
          }),
        }
      ),
    }),
  }
);

export const { useLazyGetInsightDataQuery, useGetInsightDataQuery } =
  insightDashboardApiEndpoints;
